const STORAGE_PREFIX = "autoSettleSelection_";

export const getAutoSettleSelectionKey = (userId) =>
  `${STORAGE_PREFIX}${userId}`;

export const loadAutoSettleSelection = (userId) => {
  if (userId === undefined || userId === null || userId === "") {
    return null;
  }
  try {
    const raw = localStorage.getItem(getAutoSettleSelectionKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.accountType?.value == null) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const saveAutoSettleSelection = (userId, { accountType, client }) => {
  if (userId === undefined || userId === null || userId === "") return;
  if (!accountType?.value) {
    clearAutoSettleSelection(userId);
    return;
  }
  localStorage.setItem(
    getAutoSettleSelectionKey(userId),
    JSON.stringify({
      accountType: {
        value: accountType.value,
        label: accountType.label,
      },
      client:
        client?.value != null
          ? { value: client.value, label: client.label }
          : null,
    })
  );
};

export const clearAutoSettleSelection = (userId) => {
  if (userId === undefined || userId === null || userId === "") return;
  localStorage.removeItem(getAutoSettleSelectionKey(userId));
};
